import { Elements, PaymentRequestButtonElement } from '@stripe/react-stripe-js'
import { observer } from 'mobx-react-lite'
import type { ApplePayViewModel } from '@/features/billing/profile/ApplePayViewModel'

export interface ApplePayButtonContainerProps {
  vm: ApplePayViewModel
  colorScheme: string
}

export const ApplePayButtonContainer = observer(
  function ApplePayButtonContainer({
    vm,
    colorScheme,
  }: ApplePayButtonContainerProps) {
    if (!vm.stripe || !vm.paymentRequest) {
      return null
    }

    return (
      <Elements stripe={vm.stripe}>
        <PaymentRequestButtonElement
          key={colorScheme}
          onClick={() => vm.showApplePay()}
          options={{
            paymentRequest: vm.paymentRequest,
            style: {
              paymentRequestButton: {
                type: 'default',
                theme: colorScheme === 'light' ? 'dark' : 'light',
                height: '48px',
              },
            },
          }}
        />
      </Elements>
    )
  },
)
